import React from 'react';
import { Table, TableBody, TableRow, TableCell } from '@mui/material';
import { attrNames, booleanAttr, dateAttr, numberAttr, percentAttr, priceAttr, formatValue } from '../DashboardShortcuts/KnownDevelopments/TransactionAttributes';

const PDFTransaction = (props) => {
  const { storeDetails, transactionData, transactionAttrData } = props;
  const subHeading = ["contactTitle", "facTitle", "deedTitle"];
  const contactList = ["brokercompanyname", "contactpersonname", "phonenumber", "email"];
  let contactCount = 0;

  return (
    <div className="pdf-widget-knownDev">
      <div className="table-responsive mt-4" style={{ height: '100%' }}>
        <h5 className="kd-sub-title">{storeDetails?.propertyname ? (storeDetails?.propertyname + ", ") : ""}
          <span className='tab-address'>{(storeDetails?.address ? (storeDetails?.address + ", ") : "") + (storeDetails?.city ? (storeDetails?.city + ", ") : "") + (storeDetails?.state ? (storeDetails?.state + " ") : "") + (storeDetails?.zipcode ?? "")}</span>
            {transactionData[0]?.ownershiptype ? ` (Ownership Type: ${transactionData[0].ownershiptype})` : ""}
            </h5>
        <Table className="flat-table known_dev_table" aria-label="simple table">
          <TableBody>
            {transactionAttrData.filter(ft => ft !== "ownershiptype").map((ft, idx) =>
                subHeading.includes(ft) ? (
                  <TableRow key={"pdf-row" + Math.random()}>
                    <TableCell className='bg-white font-weight-bold' colSpan={transactionData.length + 1}>{attrNames[ft]}</TableCell>
                  </TableRow>
                ) : (
                  <TableRow key={"pdf-row" + Math.random()}>
                    {[{}, ...transactionData].map((dt, idy) =>
                      idy === 0 ? (
                        ft.includes("Contact ") ? (
                          <TableCell className='bg-white' colSpan={transactionData.length + 1}>
                            {ft}{contactCount = contactCount + 1}
                          </TableCell>
                        ) : (<TableCell>{attrNames[ft] ?? ""}</TableCell>)
                      ) : !ft.includes("Contact ") && (ft.includes("mainHeader") ? (
                          <TableCell className='bg-white font-weight-bold'>
                            {dt[ft] ? dt[ft] : "-"}
                          </TableCell>
                        ) : contactList.includes(ft) ? (
                          <TableCell>
                            {dt.transContactData[contactCount - (contactCount ? 1 : 0)]?.[ft] ? dt.transContactData[contactCount - (contactCount ? 1 : 0)][ft] : "-"}
                          </TableCell>
                        ) : (
                          <TableCell>
                            {dt[ft] ? (
                              dateAttr.includes(ft) ? formatValue("Date", dt[ft])
                                : priceAttr.includes(ft) ? formatValue("Currency", dt[ft])
                                  : numberAttr.includes(ft) ? formatValue("Number", dt[ft])
                                    : percentAttr.includes(ft) ? formatValue("Percentage", dt[ft])
                                      : booleanAttr.includes(ft) ? (dt[ft] ? "Yes" : "No")
                                        : dt[ft]
                            ) : "-"}
                          </TableCell>
                        )
                      )
                    )}
                  </TableRow>
                )
              )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}

export default PDFTransaction;